(function () {
  if (window.__pdpOptBound) return;
  window.__pdpOptBound = true;

  if (!window.__reviewVideoBound) {
    window.__reviewVideoBound = true;
    var reviewDialog = document.createElement("dialog");
    reviewDialog.className = "review-video-dialog";
    reviewDialog.setAttribute("data-review-video-dialog", "");
    reviewDialog.innerHTML = '<button type="button" class="review-video-dialog__close" data-review-video-close aria-label="Close video"></button><div class="review-video-dialog__stage" data-review-video-stage></div>';
    document.body.appendChild(reviewDialog);
    var reviewStage = reviewDialog.querySelector("[data-review-video-stage]");

    function clearReviewStage() {
      reviewStage.innerHTML = "";
    }

    function closeReviewVideo() {
      clearReviewStage();
      if (reviewDialog.open) reviewDialog.close();
    }

    function allowedReviewVideo(value, kind) {
      try {
        var url = new URL(value, window.location.origin);
        if (url.protocol !== "https:") return "";
        if (kind === "youtube") {
          var host = url.hostname;
          if (host !== "www.youtube.com" && host !== "youtube.com" && host !== "www.youtube-nocookie.com") return "";
          if (url.pathname.indexOf("/embed/") !== 0) return "";
        }
        return url.toString();
      } catch (err) {
        return "";
      }
    }

    reviewDialog.querySelector("[data-review-video-close]").addEventListener("click", closeReviewVideo);
    reviewDialog.addEventListener("close", function () {
      clearReviewStage();
      document.dispatchEvent(new CustomEvent("review-video:close"));
    });
    reviewDialog.addEventListener("click", function (event) {
      if (event.target === reviewDialog) closeReviewVideo();
    });
    document.addEventListener("click", function (event) {
      var button = event.target.closest("[data-review-video-open]");
      if (!button) return;
      var kind = button.getAttribute("data-video-kind") || "youtube";
      var src = allowedReviewVideo(button.getAttribute("data-video-src") || "", kind);
      if (!src) return;
      event.preventDefault();
      clearReviewStage();
      if (kind === "file") {
        var player = document.createElement("video");
        player.controls = true;
        player.autoplay = true;
        player.playsInline = true;
        player.src = src;
        reviewStage.appendChild(player);
      } else {
        var frame = document.createElement("iframe");
        frame.src = src + (src.indexOf("?") === -1 ? "?" : "&") + "autoplay=1&rel=0";
        frame.title = button.getAttribute("data-video-title") || "Review video";
        frame.allow = "autoplay; encrypted-media; picture-in-picture; fullscreen";
        frame.allowFullscreen = true;
        reviewStage.appendChild(frame);
      }
      if (!reviewDialog.open) reviewDialog.showModal();
      document.dispatchEvent(new CustomEvent("review-video:open"));
    });
  }

  function money(cents, format) {
    const amount = (Number(cents) / 100).toFixed(2);
    if (!format) return "$" + amount;
    return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }

  const boundReviewQuotes = new WeakSet();
  const reviewRowPause = new WeakMap();

  function updateReviewQuote(quote) {
    const overflowing = quote.scrollHeight - quote.clientHeight > 1;
    quote.classList.toggle("is-overflowing", overflowing);
    const atEnd = !overflowing || quote.scrollTop + quote.clientHeight >= quote.scrollHeight - 2;
    quote.classList.toggle("is-scrolled-end", atEnd);
    const card = quote.parentElement;
    const clone = !!(card && card.getAttribute("data-pdp-review-clone") === "true");
    if (overflowing && !clone) quote.setAttribute("tabindex", "0");
    else quote.removeAttribute("tabindex");
  }

  function syncReviewQuotes(row) {
    row.querySelectorAll(".pdp-opt__review > p").forEach(function (quote) {
      updateReviewQuote(quote);
      if (boundReviewQuotes.has(quote)) return;
      boundReviewQuotes.add(quote);
      quote.addEventListener("scroll", function () {
        updateReviewQuote(quote);
        const scroller = quote.closest("[data-pdp-review-row]");
        const pause = scroller && reviewRowPause.get(scroller);
        if (pause) pause();
      }, { passive: true });
    });
  }

  function watchReviewQuoteSize(row) {
    if (row.dataset.pdpQuoteWatch === "true") return;
    row.dataset.pdpQuoteWatch = "true";
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () {
        if (row.isConnected) syncReviewQuotes(row);
      });
    }
    if (window.ResizeObserver) {
      const observer = new ResizeObserver(function () {
        syncReviewQuotes(row);
      });
      observer.observe(row);
    }
  }

  function refreshReviewRow(row) {
    const previous = row.scrollLeft || 0;
    const sources = Array.from(row.children).filter(function (card) {
      return card.getAttribute("data-pdp-review-clone") !== "true";
    });
    row.querySelectorAll("[data-pdp-review-clone]").forEach(function (clone) {
      clone.remove();
    });
    if (sources.length < 2) {
      syncReviewQuotes(row);
      return;
    }
    sources.forEach(function (card) {
      const clone = card.cloneNode(true);
      clone.setAttribute("aria-hidden", "true");
      clone.setAttribute("data-pdp-review-clone", "true");
      row.appendChild(clone);
    });
    syncReviewQuotes(row);
    if (row.dataset.pdpReviewBound === "true") {
      const half = row.scrollWidth / 2;
      if (!half) return;
      let value = previous;
      while (value >= half) value -= half;
      while (value < 0) value += half;
      row.scrollLeft = value;
    }
  }

  function initReviewRow(row) {
    if (!row) return;
    watchReviewQuoteSize(row);
    if (row.dataset.pdpReviewBound === "true") {
      refreshReviewRow(row);
      return;
    }
    const cards = Array.from(row.children).filter(function (card) {
      return card.getAttribute("data-pdp-review-clone") !== "true";
    });
    if (cards.length < 2) {
      syncReviewQuotes(row);
      return;
    }
    row.dataset.pdpReviewBound = "true";
    refreshReviewRow(row);

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let paused = false;
    let dragging = false;
    let dragged = false;
    let pointerId = null;
    let startX = 0;
    let startScroll = 0;
    let last = 0;
    let resumeTimer = 0;
    const speed = 36;

    reviewRowPause.set(row, function () {
      paused = true;
      window.clearTimeout(resumeTimer);
      resumeTimer = window.setTimeout(function () {
        if (!dragging && !row.matches(":hover") && !row.contains(document.activeElement)) paused = false;
      }, 1600);
    });

    function halfWidth() {
      return row.scrollWidth / 2;
    }

    function wrap(value) {
      const half = halfWidth();
      if (!half) return value;
      while (value >= half) value -= half;
      while (value < 0) value += half;
      return value;
    }

    function tick(now) {
      if (!last) last = now;
      const delta = Math.min(48, now - last);
      last = now;
      if (!reduce && !paused && !dragging) {
        row.scrollLeft = wrap(row.scrollLeft + (speed * delta) / 1000);
      }
      window.requestAnimationFrame(tick);
    }

    row.addEventListener("mouseenter", function () { paused = true; });
    row.addEventListener("mouseleave", function () {
      if (!dragging) paused = false;
    });
    row.addEventListener("focusin", function () { paused = true; });
    row.addEventListener("focusout", function () {
      if (!dragging && !row.matches(":hover")) paused = false;
    });

    function pointerOnQuoteScrollbar(event) {
      const quote = event.target.closest(".pdp-opt__review > p");
      if (!quote || !row.contains(quote)) return false;
      if (quote.scrollHeight - quote.clientHeight <= 1) return false;
      const gutter = quote.offsetWidth - quote.clientWidth;
      if (gutter <= 1) return false;
      return event.clientX >= quote.getBoundingClientRect().right - gutter - 4;
    }

    row.addEventListener("pointerdown", function (event) {
      if (event.pointerType === "touch") {
        paused = true;
        return;
      }
      if (event.button !== 0) return;
      if (event.target.closest("a, button, input, textarea, select")) return;
      if (pointerOnQuoteScrollbar(event)) return;
      dragging = true;
      dragged = false;
      paused = true;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = row.scrollLeft;
      row.classList.add("is-dragging");
      try { row.setPointerCapture(event.pointerId); } catch (err) {}
    });

    row.addEventListener("pointermove", function (event) {
      if (!dragging || event.pointerId !== pointerId) return;
      const delta = event.clientX - startX;
      if (!dragged && Math.abs(delta) < 6) return;
      dragged = true;
      row.scrollLeft = wrap(startScroll - delta);
      if (event.cancelable) event.preventDefault();
    }, { passive: false });

    function endDrag(event) {
      if (event && event.pointerType === "touch") {
        paused = row.matches(":hover");
        return;
      }
      if (!dragging) return;
      if (event && pointerId !== null && event.pointerId !== pointerId) return;
      dragging = false;
      pointerId = null;
      row.classList.remove("is-dragging");
      if (!row.matches(":hover")) paused = false;
    }

    row.addEventListener("pointerup", endDrag);
    row.addEventListener("pointercancel", endDrag);
    row.addEventListener("click", function (event) {
      if (!dragged) return;
      event.preventDefault();
      event.stopPropagation();
      dragged = false;
    }, true);

    if (!reduce) window.requestAnimationFrame(tick);
  }

  function reviewTextKey(value) {
    return String(value || "").replace(/\s+/g, " ").trim().toLowerCase();
  }

  function rememberReviewCard(seen, card) {
    const id = card.getAttribute("data-review-id");
    if (id) seen.add("id:" + id);
    const text = reviewTextKey(card.getAttribute("data-review-text") || (card.querySelector("p") && card.querySelector("p").textContent));
    if (text) seen.add("text:" + text);
  }

  function safeMediaUrl(value) {
    if (typeof value !== "string" || !value.trim()) return "";
    try {
      const url = new URL(value.trim());
      if (url.protocol !== "https:" && url.protocol !== "http:") return "";
      return url.toString();
    } catch (err) {
      return "";
    }
  }

  function videoUrl(review) {
    if (!review) return "";
    const direct = safeMediaUrl(review.video_url);
    if (direct) return direct;
    const videos = Array.isArray(review.videos) ? review.videos : [];
    for (let i = 0; i < videos.length; i += 1) {
      const item = videos[i];
      const url = safeMediaUrl(item && (item.url || item.original)) || safeMediaUrl(item);
      if (url) return url;
    }
    const ids = review.video_external_ids;
    const youtube = ids && Array.isArray(ids.youtube) ? ids.youtube[0] : "";
    if (typeof youtube === "string" && /^[\w-]{6,}$/.test(youtube)) {
      return "https://www.youtube.com/embed/" + youtube;
    }
    return "";
  }

  function reviewStarCount(review) {
    const rating = Number(review && review.rating);
    if (!Number.isFinite(rating)) return 0;
    return Math.max(0, Math.min(5, Math.round(rating)));
  }

  function isVerifiedBuyer(review) {
    if (!review) return false;
    if (review.verified_buyer === true || review.verified_buyer === "true") return true;
    const verified = String(review.verified || "").trim().toLowerCase();
    return verified === "buyer" || verified === "confirmed-buyer" || verified === "verified-purchase";
  }

  function reviewCardElements(review, showStars, showVerified) {
    const body = String((review && (review.body || review.title)) || "").trim();
    const video = videoUrl(review);
    const name = String((review && review.reviewer_name) || "").trim();
    const role = showVerified && isVerifiedBuyer(review) ? "Verified buyer" : "";
    if (!body && !video) return [];

    const cards = [];
    if (body) {
      const article = document.createElement("article");
      article.className = "pdp-opt__review";
      if (review.id) article.setAttribute("data-review-id", String(review.id));
      article.setAttribute("data-review-text", body);

      if (showStars) {
        const stars = document.createElement("div");
        stars.className = "pdp-opt__review-stars";
        stars.setAttribute("role", "img");
        const rating = reviewStarCount(review);
        stars.setAttribute("aria-label", rating + " out of 5 stars");
        const starSrc = (document.querySelector("[data-star-src]") || {}).getAttribute && document.querySelector("[data-star-src]").getAttribute("data-star-src");
        for (let i = 1; i <= 5; i += 1) {
          const star = document.createElement("img");
          star.src = starSrc || "";
          star.width = 14;
          star.height = 14;
          star.alt = "";
          if (i > rating) star.className = "is-empty";
          stars.appendChild(star);
        }
        article.appendChild(stars);
      }

      const quote = document.createElement("p");
      quote.textContent = body;
      article.appendChild(quote);

      const meta = document.createElement("div");
      if (name) {
        const reviewer = document.createElement("strong");
        reviewer.textContent = name;
        meta.appendChild(reviewer);
      }
      if (role) {
        const note = document.createElement("em");
        note.textContent = role;
        meta.appendChild(note);
      }
      article.appendChild(meta);
      cards.push(article);
    }

    if (video) {
      const article = document.createElement("article");
      article.className = "pdp-opt__review pdp-opt__review--media pdp-opt__review--video";
      if (!body && review.id) article.setAttribute("data-review-id", String(review.id));
      const embedMatch = String(video).match(/\/embed\/([\w-]{6,})/);
      const youtubeId = embedMatch ? embedMatch[1] : "";
      if (youtubeId) {
        const poster = document.createElement("img");
        poster.className = "pdp-opt__review-poster";
        poster.src = "https://i.ytimg.com/vi/" + youtubeId + "/hqdefault.jpg";
        poster.alt = "";
        poster.width = 320;
        poster.height = 440;
        poster.loading = "lazy";
        article.appendChild(poster);
      }
      const watch = document.createElement("button");
      watch.type = "button";
      watch.className = "pdp-opt__review-play";
      watch.setAttribute("data-review-video-open", "");
      watch.setAttribute("data-video-kind", youtubeId ? "youtube" : "file");
      watch.setAttribute("data-video-src", youtubeId ? "https://www.youtube-nocookie.com/embed/" + youtubeId : video);
      watch.setAttribute("data-video-title", name ? "Watch video from " + name : "Watch review video");
      watch.setAttribute("aria-label", name ? "Watch video from " + name : "Watch review video");
      watch.innerHTML = '<span class="pdp-opt__review-play-icon" aria-hidden="true"></span><span>Watch</span>';
      article.appendChild(watch);
      cards.push(article);
    }

    return cards;
  }

  function ensureReviewRow(feed) {
    const existing = feed.querySelector("[data-pdp-review-row]");
    if (existing) return existing;
    const row = document.createElement("div");
    row.className = "pdp-opt__review-row";
    row.setAttribute("data-pdp-review-row", "");
    const panel = feed.querySelector(".pdp-opt__reviews") || feed;
    const heading = panel.querySelector("h2");
    if (heading) heading.after(row);
    else panel.prepend(row);
    return row;
  }

  function judgeReviewReady() {
    const api = window.jdgm;
    return Boolean(api && api.$ && typeof api._WriteReviewModal === "function" && typeof api._rtlStarsEnabled === "function");
  }

  function omitReviewWidget(widget) {
    const api = window.jdgm;
    if (!api || !api.$ || !api.caches || !api.caches.$revWidgets) return;
    api.caches.$revWidgets = api.caches.$revWidgets.not(widget);
  }

  function loadJudgeReviewScripts(widget, done) {
    if (judgeReviewReady()) {
      done(true);
      return;
    }

    let finished = false;
    function finish(ok) {
      if (finished) return;
      finished = true;
      window.clearInterval(chain);
      done(ok);
    }

    const started = Date.now();
    const chain = window.setInterval(function () {
      const api = window.jdgm;
      if (judgeReviewReady()) {
        finish(true);
        return;
      }
      if (Date.now() - started > 8000) {
        finish(false);
        return;
      }
      if (!api || typeof api.loadScript !== "function") return;

      const host = api.CDN_HOST || "https://cdnwidget.judge.me/";
      if (typeof api.loadCSS === "function") {
        const css = typeof api.widgetPath === "function" ? api.widgetPath("form.css") : host + "widget_v3/form.css";
        api.loadCSS(css);
      }
      if (!api.$) {
        api.loadScript(host + "widget/base.js");
        return;
      }
      if (!api.caches) {
        api.loadScript(host + "widget/common.js");
        return;
      }
      omitReviewWidget(widget);
      if (typeof api._WriteReviewModal !== "function") {
        api.loadScript(host + "widget/write_review_modal.js");
        return;
      }
      api.loadScript(host + "widget/form.js");
    }, 50);
  }

  function showReviewModal(widget) {
    const existing = widget._pdpReviewModal;
    if (existing) {
      if (existing.$modal && existing.$modal[0] && document.body.contains(existing.$modal[0])) existing.showModalPage();
      return;
    }

    document.querySelectorAll(".jdgm-write-review-modal").forEach(function (modal) {
      modal.remove();
    });

    const modal = new window.jdgm._WriteReviewModal(window.jdgm.$);
    widget._pdpReviewModal = modal;
    modal.setup("jdgm-review-widget-modal", widget.getAttribute("data-id")).then(function () {
      modal.showModalPage();
    }).catch(function () {
      widget._pdpReviewModal = null;
    });
  }

  function openLeaveReview(root) {
    const widget = root.querySelector("[data-pdp-judge-form]");
    if (!widget || widget.dataset.pdpReviewOpening === "true") return;
    widget.dataset.pdpReviewOpening = "true";
    const watchdog = window.setTimeout(function () {
      widget.dataset.pdpReviewOpening = "";
    }, 8000);

    loadJudgeReviewScripts(widget, function (ready) {
      window.clearTimeout(watchdog);
      widget.dataset.pdpReviewOpening = "";
      if (!ready) return;
      showReviewModal(widget);
    });
  }

  function loadReviewPages(feed) {
    const productId = feed.getAttribute("data-product-id");
    const endpoint = feed.getAttribute("data-reviews-url");
    if (!productId || !endpoint || feed.dataset.pdpReviewFeedBound === "true") return;
    feed.dataset.pdpReviewFeedBound = "true";

    const perPage = Math.max(1, Number(feed.getAttribute("data-per-page")) || 10);
    const seen = new Set();
    feed.querySelectorAll("[data-pdp-review-row] > :not([data-pdp-review-clone])").forEach(function (card) {
      rememberReviewCard(seen, card);
    });

    const maxPages = 40;
    let page = 1;
    let duplicatePages = 0;

    function finishPage(reviews) {
      const row = ensureReviewRow(feed);
      const fresh = [];
      reviews.forEach(function (review) {
        const cards = reviewCardElements(review, feed.hasAttribute("data-show-stars"), feed.hasAttribute("data-show-verified"));
        if (!cards.length) return;
        const id = cards[0].getAttribute("data-review-id");
        const text = reviewTextKey(cards[0].getAttribute("data-review-text"));
        if ((id && seen.has("id:" + id)) || (text && seen.has("text:" + text))) return;
        if (id) seen.add("id:" + id);
        if (text) seen.add("text:" + text);
        cards.forEach(function (card) { fresh.push(card); });
      });
      if (!fresh.length) {
        duplicatePages += 1;
        return reviews.length > 0 && duplicatePages < 2;
      }
      duplicatePages = 0;
      fresh.forEach(function (card) { row.appendChild(card); });
      const widget = feed.querySelector(".jdgm-review-widget");
      if (widget) widget.hidden = true;
      const visibleCards = row.querySelectorAll(".pdp-opt__review:not([data-pdp-review-clone])").length;
      const rated = Number(feed.getAttribute("data-rating-count")) || 0;
      const enough = Math.max(rated, visibleCards) >= 5;
      const keepForReviewer = Boolean(feed.querySelector("[data-pdp-leave-review], .pdp-opt__review-cta"));
      feed.hidden = !enough && !keepForReviewer;
      const sectionWrap = feed.closest(".pdp-opt-section");
      if (sectionWrap) sectionWrap.hidden = feed.hidden;
      if (!feed.hidden) initReviewRow(row);
      return reviews.length > 0;
    }

    function nextPage() {
      if (page > maxPages) return;
      const url = new URL(endpoint, window.location.origin);
      url.searchParams.set("shopifyProductId", productId);
      url.searchParams.set("page", String(page));
      url.searchParams.set("perPage", String(perPage));
      fetch(url.toString(), { headers: { Accept: "application/json" }, credentials: "omit" })
        .then(function (response) {
          if (!response.ok) return null;
          return response.json();
        })
        .then(function (data) {
          if (!data || !Array.isArray(data.reviews) || !data.reviews.length) return;
          page += 1;
          if (finishPage(data.reviews)) nextPage();
        })
        .catch(function () {});
    }

    nextPage();
  }

  function stickyBarHeight(el) {
    if (!el) return 0;
    const style = window.getComputedStyle(el);
    if (style.position !== "sticky" && style.position !== "fixed") return 0;
    const height = el.getBoundingClientRect().height;
    return height > 0 ? height : 0;
  }

  function syncGalleryStickyOffset() {
    const roots = document.querySelectorAll("[data-pdp-opt]");
    if (!roots.length) return;
    const seen = new Set();
    let offset = 0;

    function add(el) {
      if (!el || seen.has(el)) return;
      seen.add(el);
      offset += stickyBarHeight(el);
    }

    document.querySelectorAll("#shopify-section-alert-bar, #shopify-section-announcement-bar").forEach(add);

    let nav = document.querySelector(".cc-nav");
    while (nav && nav !== document.body) {
      if (stickyBarHeight(nav)) {
        add(nav);
        break;
      }
      nav = nav.parentElement;
    }

    if (!offset) return;
    const value = Math.ceil(offset) + "px";
    roots.forEach(function (root) {
      root.style.setProperty("--pdp-opt-nav-offset", value);
    });
  }

  syncGalleryStickyOffset();
  window.addEventListener("resize", syncGalleryStickyOffset);

  function primeStageImage(img) {
    if (!img || img.getAttribute("src")) return;
    const src = img.getAttribute("data-src");
    if (!src) return;
    const srcset = img.getAttribute("data-srcset");
    const sizes = img.getAttribute("data-sizes");
    if (srcset) img.setAttribute("srcset", srcset);
    if (sizes) img.setAttribute("sizes", sizes);
    img.setAttribute("src", src);
  }

  const reviewFeedStarts = [];

  document.querySelectorAll("[data-pdp-opt]").forEach(function (root) {
    const format = root.getAttribute("data-money-format") || "${{amount}}";
    const stage = root.querySelector("[data-pdp-stage]");
    const thumbs = Array.from(root.querySelectorAll("[data-pdp-thumb]"));
    const dots = Array.from(root.querySelectorAll("[data-pdp-dot]"));
    const stageImages = stage ? Array.from(stage.querySelectorAll("[data-pdp-stage-img]")) : [];

    function visibleOf(list) {
      return list.filter(function (el) { return !el.hidden; });
    }

    let index = 0;
    const startingImages = visibleOf(stageImages);
    const activePos = startingImages.findIndex(function (img) { return img.classList.contains("is-active"); });
    if (activePos >= 0) index = activePos;
    else if (startingImages[0]) startingImages[0].classList.add("is-active");

    function show(next) {
      const images = visibleOf(stageImages);
      const thumbList = visibleOf(thumbs);
      const dotList = visibleOf(dots);
      const count = images.length || thumbList.length;
      if (!count || !stage) return;
      index = ((next % count) + count) % count;
      const image = images[index];
      if (image) primeStageImage(image);
      stageImages.forEach(function (img) { img.classList.toggle("is-active", img === image); });
      const thumb = thumbList[index];
      thumbs.forEach(function (el) { el.classList.toggle("is-active", el === thumb); });
      if (thumb) {
        const scroller = thumb.closest(".pdp-opt__thumb-window");
        if (scroller) {
          const scrollerRect = scroller.getBoundingClientRect();
          const thumbRect = thumb.getBoundingClientRect();
          if (thumbRect.left < scrollerRect.left) {
            scroller.scrollBy({ left: thumbRect.left - scrollerRect.left, behavior: "smooth" });
          } else if (thumbRect.right > scrollerRect.right) {
            scroller.scrollBy({ left: thumbRect.right - scrollerRect.right, behavior: "smooth" });
          }
        }
      }
      const dot = dotList[index];
      dots.forEach(function (el) {
        const on = el === dot;
        el.classList.toggle("is-active", on);
        if (on) el.setAttribute("aria-current", "true");
        else el.removeAttribute("aria-current");
      });
    }

    thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () { show(visibleOf(thumbs).indexOf(thumb)); });
    });
    dots.forEach(function (dot) {
      dot.addEventListener("click", function () { show(visibleOf(dots).indexOf(dot)); });
    });
    root.querySelectorAll("[data-pdp-thumb-dir]").forEach(function (button) {
      button.addEventListener("click", function () {
        show(index + Number(button.getAttribute("data-pdp-thumb-dir")));
      });
    });

    if (stageImages.length) {
      const activeImage = stageImages[index] || stageImages[0];
      const primeHidden = function () {
        stageImages.forEach(primeStageImage);
      };
      if (!activeImage || activeImage.complete) primeHidden();
      else {
        activeImage.addEventListener("load", primeHidden, { once: true });
        activeImage.addEventListener("error", primeHidden, { once: true });
      }
    }

    if (stage && stageImages.length > 1) {
      let swipeX = 0;
      let swipeY = 0;
      let swipeTracking = false;

      stage.addEventListener("touchstart", function (event) {
        if (event.touches.length !== 1) {
          swipeTracking = false;
          return;
        }
        swipeX = event.touches[0].clientX;
        swipeY = event.touches[0].clientY;
        swipeTracking = true;
        const visibleImages = visibleOf(stageImages);
        if (visibleImages.length > 1) {
          primeStageImage(visibleImages[(index + 1) % visibleImages.length]);
          primeStageImage(visibleImages[(index - 1 + visibleImages.length) % visibleImages.length]);
        }
      }, { passive: true });

      stage.addEventListener("touchmove", function (event) {
        if (!swipeTracking || event.touches.length !== 1) return;
        const dx = event.touches[0].clientX - swipeX;
        const dy = event.touches[0].clientY - swipeY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 12 && event.cancelable) event.preventDefault();
      }, { passive: false });

      stage.addEventListener("touchend", function (event) {
        if (!swipeTracking) return;
        swipeTracking = false;
        const touch = event.changedTouches[0];
        if (!touch) return;
        const dx = touch.clientX - swipeX;
        const dy = touch.clientY - swipeY;
        if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return;
        show(index + (dx < 0 ? 1 : -1));
      }, { passive: true });

      stage.addEventListener("touchcancel", function () {
        swipeTracking = false;
      }, { passive: true });
    }

    const priceEl = root.querySelector("[data-pdp-live-price]");
    const suggestedRetail = new Map();
    let breaks = JSON.parse(root.getAttribute("data-price-breaks") || "[]");
    let basePrice = Number(root.getAttribute("data-base-price") || 0);

    function unitPrice(quantity) {
      let price = basePrice;
      breaks.forEach(function (tier) {
        const min = Number(tier.min);
        const tierPrice = Number(tier.price);
        if (min > 1 && quantity >= min && tierPrice > 0 && tierPrice < price) price = tierPrice;
      });
      return price;
    }

    function writeQty(input, quantity) {
      const next = String(Math.max(1, quantity));
      if (input.value !== next) input.value = next;
      input.setAttribute("value", next);
    }

    function saleUnit(quantity) {
      const unit = unitPrice(quantity);
      const percent = Number(root.getAttribute("data-practitioner-percent") || 0);
      if (percent <= 0) return unit;
      return unit - Math.round((unit * percent) / 100);
    }

    function paintSuggestedRetail(unit) {
      const line = root.querySelector("[data-pdp-srp]");
      const value = root.querySelector("[data-pdp-srp-value]");
      const strike = root.querySelector("[data-pdp-retail-compare]");
      if (!line && !strike) return;
      const cents = Number(root.getAttribute("data-suggested-retail") || 0);
      if (value && cents > 0) value.textContent = money(cents, format);
      if (line) line.hidden = cents <= 0;
      if (strike) {
        const showStrike = cents > unit;
        strike.hidden = !showStrike;
        if (showStrike) strike.textContent = money(cents, format);
      }
    }

    function isSubscribeSelected() {
      const selected = root.querySelector("[data-pdp-choice].is-selected");
      return !!(selected && selected.getAttribute("data-button-label") === "Subscribe & Save" && selected.getAttribute("data-plan-id"));
    }

    function paintAdd(quantity) {
      const count = Math.max(1, quantity || 1);
      root.querySelectorAll("[data-pdp-add]").forEach(function (button) {
        if (button.disabled) {
          button.textContent = "Sold out";
          return;
        }
        let unit = saleUnit(count);
        let multiplier = count;
        if (button.hasAttribute("data-pdp-submit") && isSubscribeSelected()) {
          unit = Number(root.getAttribute("data-plan-price")) || unit;
          multiplier = 1;
        }
        button.textContent = "Add | " + money(unit * multiplier, format);
      });
    }

    function syncPrice(input) {
      if (!input) return;
      const quantity = Math.max(1, parseInt(input.value, 10) || 1);
      writeQty(input, quantity);
      const unit = unitPrice(quantity);
      const practitioner = root.getAttribute("data-audience") === "practitioner";
      if (priceEl) {
        const shown = practitioner ? unit : saleUnit(quantity);
        priceEl.textContent = money(shown, format);
      }
      const unitCompare = root.querySelector("[data-pdp-unit-compare]");
      if (unitCompare) {
        const showUnitCompare = practitioner && unit < basePrice;
        unitCompare.hidden = !showUnitCompare;
        if (showUnitCompare) unitCompare.textContent = money(basePrice, format);
      }
      const compare = root.querySelector("[data-pdp-compare]");
      if (compare) {
        const discounted = saleUnit(quantity) < unit;
        compare.hidden = !discounted;
        if (discounted) compare.textContent = money(unit, format);
      }
      paintSuggestedRetail(unit);
      paintAdd(quantity);
    }

    root.querySelectorAll("[data-pdp-qty-step]").forEach(function (button) {
      button.addEventListener("click", function () {
        const input = button.closest(".pdp-opt__buy").querySelector("[data-pdp-qty]");
        if (!input) return;
        const current = parseInt(input.value, 10);
        const step = Number(button.getAttribute("data-pdp-qty-step")) || 0;
        writeQty(input, (Number.isFinite(current) ? current : 1) + step);
        syncPrice(input);
        input.dispatchEvent(new Event("input", { bubbles: true }));
      });
    });
    root.querySelectorAll("[data-pdp-qty]").forEach(function (input) {
      input.addEventListener("input", function () {
        const digits = input.value.replace(/\D/g, "");
        if (input.value !== digits) input.value = digits;
      });
      input.addEventListener("change", function () { syncPrice(input); });
      const form = input.closest("form");
      if (form && form.dataset.pdpQtyBound !== "true") {
        form.dataset.pdpQtyBound = "true";
        form.addEventListener("submit", function () {
          form.querySelectorAll("[data-pdp-qty]").forEach(function (qtyInput) {
            syncPrice(qtyInput);
          });
        });
      }
    });

    const purchaseForm = root.querySelector("form.pdp-opt__form");
    function keepOnlyChosenSellingPlan(form) {
      if (!form) return;
      form.querySelectorAll('[name="selling_plan"]').forEach(function (field) {
        if (field.hasAttribute("data-pdp-selling-plan")) return;
        if (!field.disabled) field.disabled = true;
      });
    }
    if (purchaseForm) {
      keepOnlyChosenSellingPlan(purchaseForm);
      const planObserver = new MutationObserver(function () {
        keepOnlyChosenSellingPlan(purchaseForm);
      });
      planObserver.observe(purchaseForm, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["disabled"]
      });
    }

    const planInput = root.querySelector("[data-pdp-selling-plan]");
    const submit = root.querySelector("[data-pdp-submit]");
    function isSubscribeChoice(choice) {
      return choice.getAttribute("data-button-label") === "Subscribe & Save";
    }

    root.querySelectorAll("[data-pdp-choice]").forEach(function (choice) {
      choice.addEventListener("click", function () {
        if (choice.disabled) return;
        if (isSubscribeChoice(choice) && !choice.getAttribute("data-plan-id")) return;
        root.querySelectorAll("[data-pdp-choice]").forEach(function (el) {
          el.classList.toggle("is-selected", el === choice);
          el.setAttribute("aria-pressed", el === choice ? "true" : "false");
        });
        if (planInput) {
          const planId = choice.getAttribute("data-plan-id") || "";
          planInput.value = planId;
          planInput.disabled = !planId;
        }
        const qty = root.querySelector("[data-pdp-qty]");
        paintAdd(Math.max(1, parseInt(qty && qty.value, 10) || 1));
      });
    });

    function applySizeMedia(mediaIds) {
      const ids = [];
      (mediaIds || []).forEach(function (id) {
        const key = String(id);
        if (key && ids.indexOf(key) === -1) ids.push(key);
      });
      function arrange(list) {
        if (!list.length || !ids.length) return;
        const byId = {};
        list.forEach(function (el) {
          byId[String(el.getAttribute("data-media-id"))] = el;
        });
        const ordered = [];
        const seen = {};
        ids.forEach(function (id) {
          const el = byId[id];
          if (!el || seen[id]) return;
          seen[id] = true;
          el.hidden = false;
          ordered.push(el);
        });
        list.forEach(function (el) {
          const id = String(el.getAttribute("data-media-id"));
          if (seen[id]) return;
          el.hidden = true;
          el.classList.remove("is-active");
          ordered.push(el);
        });
        let visibleIndex = 0;
        ordered.forEach(function (el) {
          if (el.hidden) return;
          visibleIndex += 1;
          if (el.hasAttribute("data-pdp-thumb")) el.setAttribute("aria-label", "View image " + visibleIndex);
          if (el.hasAttribute("data-pdp-dot")) el.setAttribute("aria-label", "Image " + visibleIndex);
        });
        const parent = list[0].parentElement;
        if (parent) ordered.forEach(function (el) { parent.appendChild(el); });
        list.length = 0;
        ordered.forEach(function (el) { list.push(el); });
      }
      if (ids.length) {
        arrange(stageImages);
        arrange(thumbs);
        arrange(dots);
      }
      const gallery = root.querySelector(".pdp-opt__gallery");
      if (gallery) gallery.classList.toggle("is-single-media", ids.length > 0 && visibleOf(stageImages).length < 2);
      show(0);
    }

    function selectSize(id, options) {
      const picker = root.querySelector("[data-pdp-sizes]");
      if (!picker) return;
      const dataEl = picker.querySelector("[data-pdp-size-data]");
      if (!dataEl) return;
      let variants = [];
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }
      if (!Array.isArray(variants)) return;
      const variant = variants.find(function (item) { return String(item.id) === String(id); });
      if (!variant) return;
      if (picker.getAttribute("data-selected") === String(variant.id) && options && options.url === false) {
        return;
      }
      picker.setAttribute("data-selected", String(variant.id));
      picker.querySelectorAll("[data-pdp-size]").forEach(function (button) {
        const on = button.getAttribute("data-pdp-size") === String(variant.id);
        button.classList.toggle("is-selected", on);
        button.setAttribute("aria-pressed", on ? "true" : "false");
      });
      const current = picker.querySelector("[data-pdp-size-current]");
      if (current) current.textContent = variant.label || "";
      const idInput = root.querySelector('.pdp-opt__form input[name="id"]');
      if (idInput) idInput.value = String(variant.id);
      basePrice = Number(variant.price) || 0;
      breaks = Array.isArray(variant.breaks) ? variant.breaks : [];
      root.setAttribute("data-base-price", String(basePrice));
      root.setAttribute("data-price-breaks", JSON.stringify(breaks));
      const previousSku = root.getAttribute("data-sku") || "";
      root.setAttribute("data-sku", variant.sku || "");
      root.setAttribute("data-plan-price", String(Number(variant.planPrice) || basePrice));
      if (variant.sku && suggestedRetail.has(variant.sku)) {
        root.setAttribute("data-suggested-retail", String(suggestedRetail.get(variant.sku)));
      } else if (Number(variant.compare) > basePrice) {
        root.setAttribute("data-suggested-retail", String(variant.compare));
      } else if ((variant.sku || "") !== previousSku) {
        root.setAttribute("data-suggested-retail", "0");
      }
      root.querySelectorAll("[data-pdp-variant-price]").forEach(function (el) {
        if (el.hasAttribute("data-pdp-live-price")) return;
        el.textContent = money(basePrice, format);
      });
      const planPrice = Number(variant.planPrice) || basePrice;
      const planCompare = Number(variant.planCompare) || 0;
      root.querySelectorAll("[data-pdp-subscribe-price]").forEach(function (el) {
        el.textContent = money(planPrice, format);
      });
      root.querySelectorAll("[data-pdp-subscribe-compare]").forEach(function (el) {
        el.textContent = planCompare > 0 ? money(planCompare, format) : "";
      });
      const badge = root.querySelector("[data-pdp-subscribe-badge]");
      if (badge) {
        if (planCompare > planPrice && planCompare > 0) {
          badge.hidden = false;
          badge.textContent = "Save " + Math.floor(((planCompare - planPrice) * 100) / planCompare) + "%";
        } else {
          badge.hidden = true;
        }
      }
      const nextPlanId = variant.planId ? String(variant.planId) : "";
      let subscribeChoice = null;
      let oneTimeChoice = null;
      root.querySelectorAll("[data-pdp-choice]").forEach(function (choice) {
        if (isSubscribeChoice(choice)) subscribeChoice = choice;
        else if (!oneTimeChoice) oneTimeChoice = choice;
      });
      if (subscribeChoice) {
        const hasPlan = !!nextPlanId;
        subscribeChoice.disabled = !hasPlan;
        subscribeChoice.hidden = !hasPlan;
        subscribeChoice.setAttribute("aria-disabled", hasPlan ? "false" : "true");
        subscribeChoice.setAttribute("data-plan-id", nextPlanId);
        if (!hasPlan && subscribeChoice.classList.contains("is-selected") && oneTimeChoice) {
          root.querySelectorAll("[data-pdp-choice]").forEach(function (el) {
            const on = el === oneTimeChoice;
            el.classList.toggle("is-selected", on);
            el.setAttribute("aria-pressed", on ? "true" : "false");
          });
        }
      }
      const perk = root.querySelector("[data-pdp-plan-perk]");
      if (perk) {
        if (nextPlanId && variant.planName) {
          perk.hidden = false;
          perk.textContent = variant.planName + " for " + money(planPrice, format);
        } else if (!nextPlanId) {
          perk.hidden = true;
        }
        const perks = perk.parentElement;
        if (perks) {
          const visiblePerk = Array.from(perks.children).some(function (el) {
            return !el.hidden && (el.textContent || "").trim();
          });
          perks.hidden = !visiblePerk;
        }
      }
      const selectedChoice = root.querySelector("[data-pdp-choice].is-selected:not([hidden])");
      if (planInput) {
        const subscribeSelected = selectedChoice && isSubscribeChoice(selectedChoice);
        if (nextPlanId && subscribeSelected) {
          planInput.value = nextPlanId;
          planInput.disabled = false;
        } else {
          planInput.value = "";
          planInput.disabled = true;
        }
      }
      const qty = root.querySelector("[data-pdp-qty]");
      if (qty) {
        writeQty(qty, 1);
        syncPrice(qty);
      } else if (priceEl) {
        priceEl.textContent = money(basePrice, format);
      }
      root.querySelectorAll('.pdp-opt__form [name="add"]').forEach(function (button) {
        button.disabled = !variant.available;
      });
      paintAdd(1);
      applySizeMedia(variant.media);
      if (!options || options.url !== false) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", String(variant.id));
        const state = { pdpVariant: String(variant.id) };
        if (options && options.replace) history.replaceState(state, "", url);
        else history.pushState(state, "", url);
      }
    }

    const sizePicker = root.querySelector("[data-pdp-sizes]");
    if (sizePicker) {
      sizePicker.querySelectorAll("[data-pdp-size]").forEach(function (button) {
        button.addEventListener("click", function () {
          const id = button.getAttribute("data-pdp-size");
          if (sizePicker.getAttribute("data-selected") === id) return;
          selectSize(id);
        });
      });
      const selectedSize = sizePicker.getAttribute("data-selected");
      if (selectedSize) {
        const currentUrl = new URL(window.location.href);
        if (currentUrl.searchParams.get("variant") !== selectedSize) {
          currentUrl.searchParams.set("variant", selectedSize);
          history.replaceState({ pdpVariant: selectedSize }, "", currentUrl);
        }
        const dataEl = sizePicker.querySelector("[data-pdp-size-data]");
        if (dataEl) {
          try {
            const variants = JSON.parse(dataEl.textContent);
            const current = Array.isArray(variants) && variants.find(function (item) {
              return String(item.id) === String(selectedSize);
            });
            if (current) applySizeMedia(current.media);
          } catch (err) {}
        }
      }
      window.addEventListener("popstate", function () {
        const nextId = new URL(window.location.href).searchParams.get("variant");
        if (!nextId || !root.isConnected) return;
        selectSize(nextId, { url: false });
      });
    }

    if (root.getAttribute("data-audience") === "practitioner" && root.getAttribute("data-product-handle")) {
      const retailSkus = [];
      const currentSku = (root.getAttribute("data-sku") || "").trim();
      if (currentSku) retailSkus.push(currentSku);
      const sizeData = root.querySelector("[data-pdp-size-data]");
      if (sizeData) {
        try {
          const sizeVariants = JSON.parse(sizeData.textContent);
          if (Array.isArray(sizeVariants)) {
            sizeVariants.forEach(function (variant) {
              const sku = String(variant && variant.sku || "").trim();
              if (sku && retailSkus.indexOf(sku) === -1) retailSkus.push(sku);
            });
          }
        } catch (err) {}
      }
      const wantedSkus = {};
      retailSkus.forEach(function (sku) { wantedSkus[sku.toLowerCase()] = sku; });

      function rememberRetail(sku, cents) {
        const key = wantedSkus[String(sku || "").trim().toLowerCase()];
        if (key && cents > 0 && !suggestedRetail.has(key)) suggestedRetail.set(key, cents);
      }

      function applyRetail() {
        const sku = (root.getAttribute("data-sku") || "").trim();
        if (sku && suggestedRetail.has(sku)) {
          root.setAttribute("data-suggested-retail", String(suggestedRetail.get(sku)));
        }
        const qty = root.querySelector("[data-pdp-qty]");
        paintSuggestedRetail(unitPrice(Math.max(1, parseInt(qty && qty.value, 10) || 1)));
      }

      function readPublicProducts(payload) {
        if (!payload || !payload.data) return;
        Object.keys(payload.data).forEach(function (key) {
          const result = payload.data[key];
          const products = result && Array.isArray(result.nodes) ? result.nodes : (result && result.variants ? [result] : []);
          products.forEach(function (product) {
            const nodes = product && product.variants && product.variants.nodes || [];
            nodes.forEach(function (variant) {
              const cents = Math.round(Number(variant && variant.price && variant.price.amount) * 100);
              rememberRetail(variant && variant.sku, cents);
            });
          });
        });
      }

      const fields = retailSkus.slice(0, 8).map(function (sku, index) {
        return "s" + index + ": search(query: " + JSON.stringify(sku) + ", first: 3, types: PRODUCT) { nodes { ... on Product { variants(first: 20) { nodes { sku price { amount } } } } } }";
      });
      const handle = root.getAttribute("data-product-handle");
      if (handle) {
        fields.push("h: product(handle: " + JSON.stringify(handle) + ") { variants(first: 20) { nodes { sku price { amount } } } }");
      }
      const publicRetail = fields.length ? fetch("https://cellcore.com/api/2026-10/graphql.json", {
        method: "POST",
        credentials: "omit",
        cache: "no-store",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ query: "query { " + fields.join(" ") + " }" })
      }).then(function (response) {
        return response.ok ? response.json() : null;
      }).then(readPublicProducts).catch(function () {}) : Promise.resolve();

      publicRetail.then(function () {
        if (retailSkus.every(function (sku) { return suggestedRetail.has(sku); }) || !handle) return null;
        return fetch("/products/" + encodeURIComponent(handle) + ".js", {
          credentials: "omit",
          cache: "no-store"
        }).then(function (response) {
          return response.ok ? response.json() : null;
        }).then(function (product) {
          if (!product || !Array.isArray(product.variants)) return;
          product.variants.forEach(function (variant) {
            rememberRetail(variant.sku, Number(variant.price) || 0);
          });
        });
      }).then(applyRetail).catch(applyRetail);
    }

    root.querySelectorAll("[data-pdp-fact-chip]").forEach(function (chip) {
      chip.addEventListener("click", function () {
        const wrap = chip.closest("[data-pdp-fact-switch]");
        if (!wrap) return;
        const id = chip.getAttribute("data-pdp-fact-chip");
        wrap.querySelectorAll("[data-pdp-fact-chip]").forEach(function (el) {
          const selected = el === chip;
          el.classList.toggle("is-selected", selected);
          el.setAttribute("aria-pressed", selected ? "true" : "false");
        });
        wrap.querySelectorAll("[data-pdp-fact-panel]").forEach(function (panel) {
          panel.hidden = panel.getAttribute("data-pdp-fact-panel") !== id;
        });
      });
    });

    root.querySelectorAll("[data-pdp-ref]").forEach(function (button) {
      button.addEventListener("click", function () {
        const body = button.nextElementSibling;
        if (!body || !body.classList.contains("pdp-opt__ref-body")) return;
        const open = body.classList.toggle("is-open");
        button.classList.toggle("is-open", open);
        const plus = button.querySelector("[data-pdp-ref-plus]");
        if (plus) plus.textContent = open ? "–" : "+";
      });
    });

    root.querySelectorAll("[data-pdp-pair-add]").forEach(function (button) {
      button.addEventListener("click", function () {
        const id = button.getAttribute("data-variant-id");
        if (!id) return;
        button.disabled = true;
        const payload = { items: [{ id: id, quantity: 1 }] };
        const addToCart = window.utils && window.utils.cart && window.utils.cart.addProduct
          ? window.utils.cart.addProduct.bind(window.utils.cart)
          : function (body) {
              return fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json", Accept: "application/json" },
                body: JSON.stringify(body)
              }).then(function (response) {
                if (!response.ok) throw new Error("Add to cart failed");
                if (typeof openCartDrawer === "function") openCartDrawer(true);
              });
            };
        addToCart(payload).then(function () {
          button.textContent = "Added";
        }).catch(function () {
          button.disabled = false;
        });
      });
    });

    root.querySelectorAll(".pdp-opt__ticker-track").forEach(function (track) {
      const distance = track.scrollWidth / 2;
      if (!distance) return;
      track.style.animationDuration = Math.max(48, Math.round(distance / 42)) + "s";
    });

    reviewFeedStarts.push(function () {
      root.querySelectorAll("[data-pdp-review-row]").forEach(initReviewRow);
      if (root.hasAttribute("data-pdp-review-feed")) loadReviewPages(root);
    });

    root.querySelectorAll("[data-pdp-leave-review]").forEach(function (button) {
      if (button.dataset.pdpLeaveReviewBound === "true") return;
      button.dataset.pdpLeaveReviewBound = "true";
      button.addEventListener("click", function () {
        openLeaveReview(root);
      });
    });

    root.addEventListener("click", function (event) {
      const play = event.target.closest("[data-pdp-play]");
      if (!play || !root.contains(play)) return;
      const video = play.parentElement.querySelector("[data-pdp-video]");
      if (!video) return;
      video.hidden = false;
      const played = video.play();
      if (played && played.catch) played.catch(function () {});
      play.hidden = true;
    });

    root.querySelectorAll(".pdp-opt__faq-item").forEach(function (item) {
      item.addEventListener("toggle", function () {
        const mark = item.querySelector("summary span");
        if (mark) mark.textContent = item.open ? "×" : "+";
      });
    });

    root.querySelectorAll("[data-pdp-kit-slider]").forEach(function (slider) {
      if (slider.dataset.pdpKitSliderBound === "true") return;
      slider.dataset.pdpKitSliderBound = "true";
      const viewport = slider.querySelector(".pdp-kit-products__viewport");
      const dots = slider.querySelectorAll("[data-pdp-kit-dot]");
      if (!viewport || !dots.length) return;

      function mobileSlider() {
        return window.matchMedia("(max-width: 749px)").matches;
      }

      function syncSlider() {
        if (!mobileSlider()) return;
        const width = viewport.clientWidth || 1;
        const index = Math.max(0, Math.min(dots.length - 1, Math.round(viewport.scrollLeft / width)));
        dots.forEach(function (dot, dotIndex) {
          if (dotIndex === index) dot.setAttribute("aria-current", "true");
          else dot.removeAttribute("aria-current");
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener("click", function () {
          if (!mobileSlider()) return;
          const index = Number(dot.getAttribute("data-pdp-kit-dot")) || 0;
          viewport.scrollTo({ left: viewport.clientWidth * index, behavior: "smooth" });
        });
      });

      viewport.addEventListener("scroll", syncSlider, { passive: true });
      window.addEventListener("resize", syncSlider);
    });
  });

  function startReviewFeeds() {
    reviewFeedStarts.forEach(function (start) { start(); });
  }

  const heroImage = document.querySelector("[data-pdp-stage] [data-pdp-stage-img].is-active[src]");
  if (heroImage && !heroImage.complete) {
    heroImage.addEventListener("load", startReviewFeeds, { once: true });
    heroImage.addEventListener("error", startReviewFeeds, { once: true });
  } else {
    startReviewFeeds();
  }
})();
